<template>
  <v-container fluid grid-list-lg pa-0 ma-0>
    <v-card flat>
      <v-card-text>
        <v-container fluid pa-0 ma-0>
          <v-layout row wrap>
            <v-flex xs6 sm4>
              <v-text-field
                label="Amount"
                v-model="fields.amount"
                :rules="amountRules"
                :disabled="!transaction.settled && !transaction.ach_rejected"
                append-icon="fa-dollar"
                box
                hide-details
              />
              <v-layout row class="ma-0 mt-1" v-if="transaction.is_cashdiscount && transaction.request_type !== 'ach'">
                <v-flex grow class="pa-1 pl-2 caption primary white--text">
                  ${{ fields.fee }}
                </v-flex>
                <v-flex shrink class="pa-1 pl-2 pr-2 pt-2 caption primary text-truncate white--text">
                  Price Adj Fee
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs6 sm4>
              <v-select
                label="Frequency"
                v-model="fields.recurring"
                :items="recurringTypes"
                :rules="recurringTypeRules"
                :disabled="!transaction.settled && !transaction.ach_rejected"
                append-icon="fa-refresh"
                box
                hide-details
              />
            </v-flex>

            <v-flex xs6 sm4>
              <v-menu
                ref="scheduleModalStartDateModal"
                :close-on-content-click="false"
                v-model="scheduleModalStartDateModal"
                :nudge-right="40"
                :return-value.sync="fields.start_date"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  label="Start Date"
                  v-model="formattedStartDate"
                  :rules="recurringStartRules"
                  :disabled="!transaction.settled && !transaction.ach_rejected"
                  append-icon="fa-calendar"
                  readonly
                  box
                  hide-details
                />
                <v-date-picker
                  v-model="fields.start_date"
                  :min="minimumStartDate"
                  @input="$refs.scheduleModalStartDateModal.save(fields.start_date)"
                />
              </v-menu>
            </v-flex>

            <v-flex xs6 sm4>
              <v-text-field
                v-if="fields.waive_fee || fields.ongoing"
                label="End Date"
                v-model="formattedEndDate"
                :rules="recurringEndRules"
                append-icon="fa-calendar"
                box
                hide-details
                disabled
              />
              <v-menu
                v-else
                ref="scheduleModalEndDateModal"
                :close-on-content-click="false"
                v-model="scheduleModalEndDateModal"
                :nudge-right="40"
                :return-value.sync="fields.end_date"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  label="End Date"
                  v-model="formattedEndDate"
                  :rules="recurringEndRules"
                  :disabled="!transaction.settled && !transaction.ach_rejected"
                  append-icon="fa-calendar"
                  readonly
                  box
                  hide-details
                />
                <v-date-picker
                  v-model="fields.end_date"
                  :min="minimumEndDate"
                  @input="$refs.scheduleModalEndDateModal.save(fields.end_date)"
                />
              </v-menu>
              <v-checkbox
                label="Ongoing"
                v-model="fields.ongoing"
                color="primary"
                box
                hide-details
                class="ma-0"
                :disabled="!transaction.settled && !transaction.ach_rejected"
              />
            </v-flex>

            <v-flex xs6 sm4>
              <v-text-field
                label="# of Payments"
                v-model="fields.recurring_payments"
                :disabled="!fields.start_date || (!transaction.settled && !transaction.ach_rejected) || fields.ongoing"
                append-icon="fa-hashtag"
                box
                hide-details
                @input="handleChange('payments')"
                :readonly="fields.ongoing"
              />
            </v-flex>

            <!--
            <v-flex xs6 sm2>
              <v-checkbox
                label="Ongoing"
                v-model="fields.ongoing"
                :disabled="!transaction.settled"
                color="primary"
                box
                hide-details
              />
            </v-flex>
            -->

            <!--
            <v-flex xs6 sm4>
              <v-text-field
                label="Expiration"
                type="tel"
                v-model="fields.card_expiration"
                append-icon="fa-calendar"
                mask="## / ##"
                box
                hide-details
              />
            </v-flex>
          -->

            <!--
            <v-flex xs6 sm4>
              <v-text-field
                label="Postal Code"
                v-model="transaction.billing_postal_code"
                append-icon="fa-info-circle"
                box
                hide-details
              />
            </v-flex>

            <v-flex xs6 sm4>
              <v-text-field
                label="Phone"
                v-model="transaction.billing_phone"
                append-icon="fa-phone"
                box
                hide-details
              />
            </v-flex>
            -->

            <!--
            <v-flex xs6 sm4>
              <v-text-field
                label="Email"
                v-model="transaction.billing_email"
                append-icon="fa-at"
                box
                hide-details
              />
            </v-flex>
          -->

          </v-layout>

          <v-layout row wrap>
            <v-flex xs2 v-if="transaction.is_recurring===1">
              <!--
              <v-checkbox
                label="Cancel Recurring"
                v-model="fields.cancel"
                color="primary"
                hide-details
              />
              -->
              <!--
              <v-checkbox
                label="Recurring Email"
                v-model="fields.recurring_notify"
                color="primary"
                box
                hide-details
              />
              -->
            </v-flex>

          </v-layout>

          <v-divider class="primary"></v-divider>
          <v-layout row wrap>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="recreate" v-if="!transaction.settled && !transaction.ach_rejected">Edit Schedule</v-btn>
            <v-btn color="primary" @click="save" v-if="transaction.settled || transaction.ach_rejected">{{ transaction.is_recurring===1 ? 'Save' : 'Create' }} Schedule</v-btn>
            <v-btn color="error" @click="cancel" v-if="scheduledTransactions.length">Cancel Schedule</v-btn>
          </v-layout>

        </v-container>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import Moment from 'moment'

import Bus from '@/bus'
import ApiMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import CashDiscountMixin from '@/mixins/cashDiscount'
import DisplayMixin from '@/mixins/display'
import RecurringMixin from '@/mixins/recurring'
import StoreMixin from '@/store/mixin'

export default {
  mixins: [ApiMixin, AuthMixin, CashDiscountMixin, DisplayMixin, RecurringMixin, StoreMixin],

  data: function () {
    return {
      enabled: false,
      scheduleModalStartDateModal: false,
      scheduleModalEndDateModal: false,
      recurringTypes: [
        {value: 'none', text: 'None'},
        {value: 'daily', text: 'Every day'},
        {value: 'weekly', text: 'Every week'},
        {value: 'biweekly', text: 'Every 2 weeks'},
        {value: 'triweekly', text: 'Every 3 weeks'},
        {value: 'monthly', text: 'Every month'},
        {value: 'bimonthly', text: 'Every 2 months'},
        {value: 'quarterly', text: 'Every 4 months'},
        {value: 'semiannually', text: 'Every 6 months'},
        {value: 'annually', text: 'Every 12 months'}
      ],

      amountRules: [
        (v) => !!v || 'Amount is required'
      ],
      recurringTypeRules: [
        (v) => !!v || 'Recurring type is required'
      ],
      recurringStartRules: [
        (v) => !!v || 'Recurring start date is required'
      ],
      recurringEndRules: [
        (v) => !!v || 'Recurring end date is required'
      ],
      // expirationRules: [
      //   (v) => !!v || 'Expiration is required'
      // ],

      current_date: Moment().format('YYYY-MM-DD'),

      fields: {
        api_transaction_id: '',
        api_token_id: '',
        token_id: 0,
        billing_id: 0,
        billing_postalcode: null,
        billing_phone: null,
        billing_email: null,
        amount: null,
        fee: '0.00',
        fee_waived: '0.00',
        card_month: null,
        card_year: null,
        card_expiration: '',
        ach_routing_number: null,
        ach_account_number: null,
        percentage: 0,
        recurring: 'none',
        start_date: '',
        end_date: '',
        recurring_notify: null,
        recurring_payments: 0,
        ongoing: false,
        waive_fee: false,
        cancel: false
      }
    }
  },

  props: {
    transaction: Object,
    scheduledTransactions: Array
  },

  mounted () {
    if (this.appReady) {
      this.init()
    } else {
      Bus.$on('appReady', this.init)
    }

    if (this.transaction && this.transaction.modify_recurring_type !== 'none' && this.transaction.is_recurring === 1) {
      // alert('set value')

      if (this.transaction.request_type === 'ach') {
        this.scheduleAmount = this.transaction.modify_total_amount ? (this.transaction.modify_total_amount / 100).toFixed(2) : (this.transaction.amount / 100).toFixed(2)
        this.fields.amount = this.transaction.modify_total_amount ? (this.transaction.modify_total_amount / 100).toFixed(2) : (this.transaction.total_amount / 100).toFixed(2)
      } else {
        this.scheduleAmount = this.transaction.modify_total_amount ? ((this.transaction.modify_total_amount - this.transaction.modify_fee_amount) / 100).toFixed(2) : ((this.transaction.amount - this.transaction.fee_amount) / 100).toFixed(2)
        this.fields.amount = this.transaction.modify_total_amount ? ((this.transaction.modify_total_amount - this.transaction.modify_fee_amount) / 100).toFixed(2) : ((this.transaction.total_amount - this.transaction.fee_amount) / 100).toFixed(2)
      }
      this.fields.fee = this.transaction.modify_fee_amount ? this.transaction.modify_fee_amount : this.transaction.fee_amount

      this.fields.recurring = this.transaction.modify_recurring_type ? this.transaction.modify_recurring_type : this.transaction.recurring_type
      this.fields.start_date = this.transaction.modify_recurring_start ? Moment.utc(this.transaction.modify_recurring_start).format('YYYY-MM-DD') : Moment.utc(this.transaction.recurring_start).format('YYYY-MM-DD')

      if (this.transaction.modify_recurring_end) {
        this.fields.end_date = Moment.utc(this.transaction.modify_recurring_end).format('YYYY-MM-DD') === '2099-12-31' ? '' : Moment.utc(this.transaction.modify_recurring_end).format('YYYY-MM-DD')

        this.fields.ongoing = !!(Moment.utc(this.transaction.modify_recurring_end).format('YYYY-MM-DD') === '2099-12-31')
      } else if (!this.transaction.recurring_end) {
        this.fields.ongoing = true
      } else {
        this.fields.end_date = Moment.utc(this.transaction.recurring_end).format('YYYY-MM-DD') === '2099-12-31' ? '' : Moment.utc(this.transaction.recurring_end).format('YYYY-MM-DD')

        this.fields.ongoing = !!(Moment.utc(this.transaction.recurring_end).format('YYYY-MM-DD') === '2099-12-31')
      }
      // this.fields.end_date = this.transaction.modify_recurring_end ? Moment(this.transaction.modify_recurring_end).format('YYYY-MM-DD') : Moment(this.transaction.recurring_end).format('YYYY-MM-DD')

      this.fields.recurring_notify = this.transaction.modify_recurring_notify ? this.transaction.modify_recurring_notify : this.transaction.recurring_notify

      this.fields.waive_fee = this.transaction.is_fee_waived
      this.fields.card_expiration = this.transaction.card_expiration_yymm.slice(-2) + ' / ' + this.transaction.card_expiration_yymm.slice(0, 2)

      this.fields.billing_postalcode = this.transaction.billing_postalcode
      this.fields.billing_phone = this.transaction.billing_phone
      this.fields.billing_email = this.transaction.billing_email
    }
  },

  computed: {
    formattedStartDate () {
      return this.fields.start_date ? Moment(this.fields.start_date).format('MMM-DD-YYYY') : ''
    },
    formattedEndDate () {
      return this.fields.end_date ? Moment(this.fields.end_date).format('MMM-DD-YYYY') : ''
    },
    minimumStartDate: function () {
      return Moment().format('YYYY-MM-DD')
    },
    minimumEndDate: function () {
      return Moment(this.fields.start_date, 'YYYY-MM-DD').add(2, 'days').format('YYYY-MM-DD')
    },
    scheduleAmount: {
      get: function () {
        return this.fields.amount
      },
      set: function (amount) {
        this.fields.amount = amount
      }
    },

    recurring: function () {
      return this.fields.recurring
    },

    recurringEndDate: function () {
      return this.fields.end_date
    },

    recurringOngoing: function () {
      return this.fields.ongoing
    }
  },

  watch: {
    scheduleAmount () {
      this.calculateScheduleFee()
    },
    recurring () {
      this.calculatePaymentCount()
    },
    recurringEndDate (val) {
      this.calculatePaymentCount()
    },
    recurringOngoing () {
      this.calculatePaymentCount()
    }
  },

  methods: {
    async init () {},

    async recreate () {
      /*
      try {
        let options = {
          terminal_id: this.transaction.terminal_id,
          transaction_id: this.transaction.id
        }

        Bus.$emit('openWaitModal')

        let result = await this.api({
          method: 'post',
          url: `/terminal/void`,
          data: options
        })
        Bus.$emit('closeWaitModal')

        if (result.data.response.ActionCode === '000') {
          let method = 'ChargeCard'
          if (this.transaction.request_type.startsWith('ach')) {
            method = 'ChargeACH'
          }

          this.$router.push({name: method, query: { rerun: this.transaction.id }})
        } else {
          let error = result.data.response.ResponseText
          if (result.data.response.ErrMsg) {
            error += ': ' + result.data.response.ErrMsg
          }

          Bus.$emit('openModal', {status: 'error', message: error})
        }
      } catch (err) {
        Bus.$emit('openModal', {status: 'error', message: err})
      }
      */
      let method = 'ChargeCard'
      if (this.transaction.request_type.startsWith('ach')) {
        method = 'ChargeACH'
      }
      this.$router.push({name: method, query: { rerun: this.transaction.id, r: 1 }})
    },

    async save () {
      try {
        if (!this.transaction || !this.transaction.token_id) {
          throw new Error('Unable to identify transaction')
        }

        // @TODO if hasn't settled, don't save
        if (!this.transaction.settled && !this.transaction.ach_rejected) {
          throw new Error('Transaction has not yet been settled, please void and recreate to edit')
        }

        let options = {
          terminal_id: this.transaction.terminal_id,
          token_id: this.transaction.token_id,
          transaction_id: this.transaction.id
          // type: this.refundType
        }

        // let options = {}

        // options.pan = this.accountSelected.id
        options.account_id = this.transaction.account_id
        options.terminal_id = this.transaction.terminal_id

        options.transaction_id = this.transaction.custom_tracking_id
        options.token_id = this.transaction.token_id
        options.billing_id = this.transaction.billing_id

        // options.total_amount = this.fields.amount * 100
        // options.fee_amount = this.fields.fee * 100
        options.total_amount = this.fields.amount

        // options.card_month = this.fields.card_month
        // options.card_year = this.fields.card_year

        // options.ach_routing_number = this.fields.ach_routing_number
        // options.ach_account_number = this.fields.ach_account_number

        options.is_recurring = true
        options.recurring_type = this.fields.recurring
        options.recurring_start = this.fields.start_date
        options.recurring_end = this.fields.end_date
        if (this.fields.ongoing) {
          options.recurring_end = '2099-12-31'
        }
        options.recurring_notify = this.fields.recurring_notify

        options.is_installment = this.transaction.is_installment

        // options.card_month = this.fields.card_expiration.slice(0, 2)
        // options.card_year = this.fields.card_expiration.slice(-2)
        options.billing_postalcode = this.fields.billing_postalcode
        options.billing_phone = this.fields.billing_phone
        options.billing_email = this.fields.billing_email

        options.waive_fee = this.transaction.is_fee_waived
        options.fee_amount = this.fields.fee
        options.fee_waived = this.fields.fee_waived

        Bus.$emit('openWaitModal')
        let result = await this.api({
          method: 'post',
          url: `/terminal/modify`,
          data: options
        })
        Bus.$emit('closeWaitModal')

        if (result.data) {
          if (result.data.response.ResponseText === 'MODIFY ACCEPTED') {
            Bus.$emit('openModal', {status: 'success', message: 'Schedule Saved'})
            Bus.$emit('closeOptionsModal')
          } else {
            let error = result.data.response.ResponseText
            if (result.data.response.ErrMsg) {
              error += ': ' + result.data.response.ErrMsg
            }
            throw new Error(error)
          }
        } else {
          Bus.$emit('openModal', {status: 'error', message: 'Unexpected Error'})
        }
      } catch (err) {
        Bus.$emit('openModal', {status: 'error', message: err})
      }
    },

    async cancel () {
      try {
        if (!this.transaction || !this.transaction.token_id) {
          throw new Error('Unable to identify transaction')
        }

        if (confirm('Cancelling is not reversable, are you absolutely sure you would like to cancel this recurring schedule?')) {
          // void if it hasn't been settled, as parent will still run even if schedule is cancelled
          if (!this.transaction.settled && !this.transaction.ach_rejected) {
            let options = {
              terminal_id: this.transaction.terminal_id,
              transaction_id: this.transaction.id
            }

            Bus.$emit('openWaitModal')
            let result = await this.api({
              method: 'post',
              url: `/terminal/void`,
              data: options
            })
            Bus.$emit('closeWaitModal')

            if (result.data) {
              if (result.data.response.ActionCode === '000') {
                Bus.$emit('openModal', {status: 'success', message: 'Schedule Cancelled'})
              } else {
                let error = result.data.response.ResponseText
                if (result.data.response.ErrMsg) {
                  error += ': ' + result.data.response.ErrMsg
                }
                throw new Error(error)
              }
            } else {
              throw new Error('Unexpected Error')
            }
          } else {
            let options = {
              account_id: this.transaction.account_id,
              terminal_id: this.transaction.terminal_id,
              token_id: this.transaction.token_id,
              unique_id: this.transaction.tracking_id,
              transaction_group_id: this.transaction.transaction_group_custom_tracking_id,
              is_recurring: true,
              is_installment: this.transaction.is_installment,
              recurring_type: 'none',
              recurring_offset: new Date().getTimezoneOffset() / 60,
              recurring_start_date: (this.transaction.modify_recurring_start ? this.transaction.modify_recurring_start : this.transaction.recurring_start),
              recurring_end_date: (this.transaction.modify_recurring_end ? this.transaction.modify_recurring_end : this.transaction.recurring_end),
              total_amount: ((this.transaction.modify_total_amount ? this.transaction.modify_total_amount : this.transaction.total_amount) - (this.transaction.modify_fee_amount ? this.transaction.modify_fee_amount : this.transaction.fee_amount)) / 100, // required for FAPS
              fee_amount: (this.transaction.modify_fee_amount ? this.transaction.modify_fee_amount : this.transaction.fee_amount) / 100 // required for modify endpoint to properly calculate
            }

            Bus.$emit('openWaitModal')
            let result = await this.api({
              method: 'post',
              url: `/terminal/modify`,
              data: options
            })
            Bus.$emit('closeWaitModal')

            if (result.data) {
              if (result.data.response.ResponseText === 'MODIFY ACCEPTED') {
                Bus.$emit('openModal', {status: 'success', message: 'Schedule Cancelled'})
                // Bus.$emit('closeOptionsModal')
              } else {
                let error = result.data.response.ResponseText
                if (result.data.response.ErrMsg) {
                  error += ': ' + result.data.response.ErrMsg
                }
                throw new Error(error)
              }
            } else {
              throw new Error('Unexpected Error')
            }
          }
        }
      } catch (err) {
        Bus.$emit('openModal', {status: 'error', message: err})
      }
    },

    calculateScheduleFee () {
      if (this.fields.waive_fee) {
        this.fields.fee = '0.00'
        this.fields.fee_waived = this.calculateFee(this.transaction, this.fields.amount)
      } else {
        this.fields.fee = this.calculateFee(this.transaction, this.fields.amount)
        this.fields.fee_waived = '0.00'
      }
    },

    calculatePaymentCount () {
      // today.diff(birthday, 'week')
      if (this.fields.recurring === 'none') {
        return
      }
      if (this.fields.start_date === '') {
        return
      }
      if (this.fields.end_date === '') {
        return
      }

      if (this.fields.ongoing) {
        this.fields.end_date = ''
        this.fields.recurring_payments = 0
        return
      }

      let startDate = Moment(this.fields.start_date)
      let endDate = Moment(this.fields.end_date)

      if (this.fields.recurring === 'daily') {
        this.fields.recurring_payments = Math.trunc(endDate.diff(startDate, 'days') + 1)
      } else if (this.fields.recurring === 'weekly') {
        this.fields.recurring_payments = Math.trunc(endDate.diff(startDate, 'weeks') + 1)
      } else if (this.fields.recurring === 'biweekly') {
        this.fields.recurring_payments = Math.trunc(endDate.diff(startDate, 'weeks') / 2 + 1)
      } else if (this.fields.recurring === 'triweekly') {
        this.fields.recurring_payments = Math.trunc(endDate.diff(startDate, 'weeks') / 3 + 1)
      } else if (this.fields.recurring === 'monthly') {
        this.fields.recurring_payments = Math.trunc(endDate.diff(startDate, 'months') + 1)
      } else if (this.fields.recurring === 'bimonthly') {
        this.fields.recurring_payments = Math.trunc(endDate.diff(startDate, 'months') / 2 + 1)
      } else if (this.fields.recurring === 'quarterly') {
        this.fields.recurring_payments = Math.trunc(endDate.diff(startDate, 'months') / 4 + 1)
      } else if (this.fields.recurring === 'semiannually') {
        this.fields.recurring_payments = Math.trunc(endDate.diff(startDate, 'months') / 6 + 1)
      } else if (this.fields.recurring === 'annually') {
        this.fields.recurring_payments = Math.trunc(endDate.diff(startDate, 'years') + 1)
      }
    },

    handleChange (field) {
      if (field === 'payments') {
        // calculate end date
        this.$set(this.fields, 'end_date', this.calculateEndDate(this.fields.recurring, this.fields.start_date, this.fields.recurring_payments))
      }
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/recurring/Modify.vue